const options = [
    { value: 'favorite', label: '기본 순' },
    { value: 'sales', label: '총 판매량 순' },
    { value: 'revenue', label: '총 매출액 순' },
    { value: 'registration', label: '등록일 순' }
];

export default options;